// Func = limiting Scope for this file
var lastScrollTop = 0;
(function () {


    window.onload = function () {
        scrollW();
        window.addEventListener('scroll', function () {
            scrollW();
        })
    };

}());

function scrollW() {
    //check scroll down or up for header styles
    let st = window.pageYOffset || document.documentElement.scrollTop;
    if (st > 80) {
        if (st > lastScrollTop) {
            // downscroll code
            if (!document.getElementById('header').classList.contains('down')) {
                document.getElementById('header').classList.add('down');
                document.getElementById('header').classList.remove('up');
            }
        } else {
            // upscroll code
            if (!document.getElementById('header').classList.contains('up')) {
                document.getElementById('header').classList.add('up');
                document.getElementById('header').classList.remove('down');
            }
        }
    } else {
        if (document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')) {
            document.getElementById('header').classList.remove('up');
            document.getElementById('header').classList.remove('down');
        }
    }
    lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

/*MOBILE MENU NAV
    ****************************************************************/

//Open Navigation
$('#menu-btn').click(function (event) {
    $('html').addClass('hide-overflow');
    $('.navigation').addClass('open');
    $('.navigation').stop().animate({ left: '0px' }, { duration: 300 });
    if ($('.navigation ul li a').hasClass('.item-open')) {
        $(".item-open").get(0).scrollIntoView(false);
    }
});

$('.close-menu').click(function (event) {
    event.preventDefault();
    $('html').removeClass('hide-overflow');
    $('.navigation').removeClass('open');
    $('.navigation').stop().animate({ left: '100%' }, { queue: false, duration: 300 });
});

//SUBNAVIGATION

// Open active sub-nav on load
$('.navigation ul.submenu li .active').closest('.inner').addClass('open')
$('.navigation ul.submenu li .active').parents().parents('li').addClass('item-open');
$('.navigation ul.submenu li .active').closest('.sub-sub-menu').slideDown(300, function () { }).addClass('menu-open');

//Toggle open/close on tap
$('.navigation li a').off('click').on('click', function (event) {
    if ($(this).parent().children(".sub-sub-menu").length > 0) {

        event.preventDefault();

        if ($(this).next().hasClass('menu-open')) {
            $(this).closest('.inner').removeClass('open');
            $('.navigation ul li').removeClass('item-open');
            $(this).parent().addClass('item-open');
            $(this).next().slideUp(300, function () {
                if ($('.navigation ul li a').hasClass('active')) {
                    $(".item-open").get(0).scrollIntoView(false);
                }
            }).removeClass('menu-open');
        } else {
            $(this).closest('.inner').addClass('open');
            $('.navigation ul li').removeClass('item-open');
            $(this).parent().addClass('item-open');
            $('.sub-sub-menu.menu-open').slideUp(300).removeClass('menu-open');
            $(this).next().addClass('menu-open').slideDown(300, function () {
                if ($('.navigation ul li a').hasClass('active')) {
                    $(".item-open").get(0).scrollIntoView(false);
                }
            });
        }
    }
});

var bookbtn = document.querySelectorAll('.js-booking-cta, .header__booking-close');
	if (bookbtn.length > 0) {
		bookbtn.forEach((ele) => {
			ele.addEventListener('click', function (e) {
				e.preventDefault();
				var menuObj = document.querySelector('.header');
				menuObj.classList.toggle('open-book');
				menuObj.classList.remove('open-nav');
			});
		})
	}